import { useParams } from 'react-router-dom';
import { OSS_CDN } from '@/utils/pathConfig';
import { Privacy } from './components/privacy/index';
import { Abstract } from './components/abstract/index';

import styles from './index.module.scss';

const Index = () => {
  const params = useParams();
  const type = Number(params.type) || 1;

  return (
    <div className={styles.protocol}>
      {/* 海底捞外送小程序隐私政策 */}
      {type == 1 ? <Privacy /> : null}
      {/* 海底捞外送小程序隐私条款摘要 */}
      {type == 2 ? <Abstract /> : null}
      {/* 个人信息收集清单 */}
      {type == 3 ? (
        <img
          alt="个人信息收集清单"
          src={`${OSS_CDN}userinfo.png`}
          className={styles.image}
        />
      ) : null}
      {/* - 第三方SDK清单 */}
      {type == 4 ? (
        <img
          alt="第三方SDK清单"
          src={`${OSS_CDN}thirdSdk.png`}
          className={styles.image}
        />
      ) : null}
      {/* 小程序与第三方共享信息清单 */}
      {type == 5 ? (
        <img
          alt="小程序与第三方共享信息清单"
          src={`${OSS_CDN}gxxxqd.png`}
          className={styles.image}
        />
      ) : null}
    </div>
  );
};

export default Index;
